import { ReactNode } from 'react';
import { Flex } from 'antd';
import Tooltip from 'components/Tooltip';
import LazySvg from 'components/LazySvg';
import If from 'components/If';
import { QaDataCollectionModal } from 'testdata/constants';
import styles from './index.module.scss';

type FieldLabelProps = {
  label?: string;
  info?: ReactNode;
};

function FieldLabel({ label, info }: FieldLabelProps) {
  if (!label) {
    return null;
  }

  return (
    <Flex align='center' className='gap8'>
      <p
        className={styles.labelText}
        data-qa-selector={`${QaDataCollectionModal.inputLabel}${label.replaceAll(' ', '-').toLowerCase()}`}
      >
        {label}
      </p>
      <If condition={!!info}>
        <Tooltip title={info}>
          <LazySvg className={styles.imgWrapper} name='info' />
        </Tooltip>
      </If>
    </Flex>
  );
}

export default FieldLabel;
